"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_1 = __importStar(require("@seaweb/coral/hoc/styled"));
var react_focus_lock_1 = require("react-focus-lock");
var StyledAutoFocusInside = styled_1.default(react_focus_lock_1.AutoFocusInside)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  width: 100%;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  box-sizing: border-box;\n  width: 100%;\n\n  ",
    "\n"])), function (_a) {
    var spacing = _a.theme.spacing;
    return styled_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    > * {\n      margin-left: ", "px;\n    }\n  "], ["\n    > * {\n      margin-left: ", "px;\n    }\n  "])), 4 * spacing.factor);
});
var DialogActionsContainer = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  box-sizing: border-box;\n  width: 100%;\n\n  ", "\n"], ["\n  box-sizing: border-box;\n  width: 100%;\n\n  ",
    "\n"])), function (_a) {
    var spacing = _a.theme.spacing;
    return styled_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    padding: ", "px;\n    padding-top: ", "px;\n  "], ["\n    padding: ", "px;\n    padding-top: ", "px;\n  "])), 6 * spacing.factor, 3 * spacing.factor);
});
var DialogActions = react_1.forwardRef(function DialogActions(_a, ref) {
    var as = _a.as, children = _a.children, props = __rest(_a, ["as", "children"]);
    return (react_1.default.createElement(DialogActionsContainer, __assign({ as: as, ref: ref }, props),
        react_1.default.createElement(StyledAutoFocusInside, null,
            react_1.default.createElement(react_1.default.Fragment, null, children))));
});
exports.default = react_1.memo(DialogActions);
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
